import React from "react";

const MenuList = (props) => {
	const renderMenuItem = (item) => {
		return (
			<div className="list-item" onClick={item.onClick}>
				<h5 className="label">{item.label}</h5>
				<p className="mice narrow desc">{item.desc}</p>
			</div>
		);
	};
	return (
		<div className="menu-list-ext-2">
			{props.options.map((element) => {
				return renderMenuItem(element);
			})}
		</div>
	);
};
export default MenuList;
